import React from 'react';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
  PolarRadiusAxis
} from 'recharts';
import * as S from './styles';

interface RadarChartProps {
  attributes: {
    label1: number;
    label2: number;
    label3: number;
    label4: number;
    label5: number;
  };
  labels: string[];
}

const RadarChartComponent: React.FC<RadarChartProps> = ({ attributes, labels }) => {
  // Formatar dados para o Recharts
  const data = [
    { subject: 'label1', value: attributes.label1, fullMark: 100 },
    { subject: 'label2', value: attributes.label2, fullMark: 100 },
    { subject: 'label3', value: attributes.label3, fullMark: 100 },
    { subject: 'label4', value: attributes.label4, fullMark: 100 },
    { subject: 'label5', value: attributes.label5, fullMark: 100 },
  ];

  return (
    <S.RadarContainer>
      {/* Rótulos com valores */}
      <S.AttributeLabel style={{ top: '5%', left: '50%', transform: 'translateX(-50%)' }}>
        <S.AttributeValue className="alt">{attributes.label1}</S.AttributeValue>
        <S.AttributeText>{labels[0]}</S.AttributeText>
      </S.AttributeLabel>
      
      <S.AttributeLabel style={{ top: '35%', right: '5%' }}>
        <S.AttributeValue className="cre">{attributes.label2}</S.AttributeValue>
        <S.AttributeText>{labels[1]}</S.AttributeText>
      </S.AttributeLabel>
      
      <S.AttributeLabel style={{ bottom: '10%', right: '17%' }}>
        <S.AttributeValue className="tec">{attributes.label3}</S.AttributeValue>
        <S.AttributeText>{labels[2]}</S.AttributeText>
      </S.AttributeLabel>
      
      <S.AttributeLabel style={{ bottom: '10%', left: '17%' }}>
        <S.AttributeValue className="def">{attributes.label4}</S.AttributeValue>
        <S.AttributeText>{labels[3]}</S.AttributeText>
      </S.AttributeLabel>
      
      <S.AttributeLabel style={{ top: '35%', left: '5%' }}>
        <S.AttributeValue className="tac">{attributes.label5}</S.AttributeValue>
        <S.AttributeText>{labels[4]}</S.AttributeText>
      </S.AttributeLabel>

      {/* Gráfico Recharts */}
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="60%" data={data}>
          <PolarGrid gridType="polygon" />
          <PolarAngleAxis 
            dataKey="subject" 
            tick={false} 
          />
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <Radar
            name="Jogador"
            dataKey="value"
            stroke="#0070f3"
            fill="#0070f3"
            fillOpacity={0.6}
          />
        </RadarChart>
      </ResponsiveContainer>
    </S.RadarContainer>
  );
};

export default RadarChartComponent; 